import React, { Component } from 'react';
import PropTypes from 'prop-types';

const enableForm = () => {
    if (window.MktoForms2) {
        window.MktoForms2.loadForm('https://app-sj07.marketo.com', '134-QHZ-485', 1437);
    } else {
        setTimeout(enableForm, 500);
    }
};

class MarketoForm extends Component {
    componentDidMount() {
        const script = document.createElement('script');
        document.body.appendChild(script);
        enableForm();
    }
    render() {
        return (
            <React.Fragment>
                <div id="marketo-form">
                    <p>Sign up to be notified when a new beta version becomes available:</p>
                    <form id="mktoForm_1437"></form>
                </div>
            </React.Fragment>
        );
    }
}

MarketoForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default MarketoForm;
